import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _authService: AuthService
  ) { }

  /**
   * Can activate
   *
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean
  {
    const redirectUrl = state.url === 'dashboard' ? '/' : state.url;
    return this._check(redirectUrl);
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Check the authenticated status
   *
   * @param redirectURL
   * @private
   */
    private _check(redirectURL: string): Observable<boolean> {
      // Check the authentication status
      return this._authService.check()
      .pipe(
        switchMap((authenticated) => {

            // If the user is not authenticated...
            if ( !authenticated ) {
              // Redirect to the login page
              this._router.navigate(['/login'], {queryParams: {redirectURL}});

              // Prevent the access
              return of(false);
            }

            // Allow the access
            return of(true);
        })
      );
    }

}
